export const WINDOW_VAR_TOKEN_NAME = 'emmaToken';
